/* lp40sub-c3 — 個数×間隔ピッカー、レビューカルーセル（自動再生あり）、スクロール演出、計測
 *
 * 通常の購入経路では、Liquid 側が既定値（40個・月1回）の購入URLを
 * href に出力する。独立Cartを作る経路だけは、JS無効時に旧Cartを加算しないよう
 * 安全な選択欄リンクを保持し、JSから型付きPOSTを1回だけ実行する。
 * 演出はすべて JS 側で付与するため、JSが動かない環境では静止した通常のページになる。
 * prefers-reduced-motion: reduce のときは自動再生もフェードインも行わない。
 * クラス名は lp3- 接頭辞で統一（テーマの base.css との衝突を避けるため）。
 */
(function () {
  'use strict';
  if (window.__lp40subC3) return;
  window.__lp40subC3 = true;

  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduceMotion = mq ? mq.matches : false;

  var deferredConsentLpView = null;
  var privacyFeatureLoadRequested = false;

  function analyticsProcessingAllowed() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!customerPrivacy || typeof customerPrivacy.analyticsProcessingAllowed !== 'function') return false;
    try {
      return customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  function flushDeferredConsentLpView() {
    if (!deferredConsentLpView || !analyticsProcessingAllowed()) return;
    var payload = deferredConsentLpView;
    deferredConsentLpView = null;
    push(payload);
  }

  function requestPrivacyFeature() {
    if (privacyFeatureLoadRequested) return;
    var shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function') return;
    privacyFeatureLoadRequested = true;
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) flushDeferredConsentLpView();
      });
    } catch (error) {
      // Keep analytics fail-closed when Shopify cannot load the consent API.
    }
  }

  function push(payload) {
    if (!payload || !payload.event || window.__suecoLpGa4Direct !== true || typeof window.gtag !== 'function') return;
    if (!analyticsProcessingAllowed()) {
      if (payload.event === 'lp_view') {
        deferredConsentLpView = payload;
        requestPrivacyFeature();
      }
      return;
    }
    if (payload.event === 'lp_view') deferredConsentLpView = null;
    var params = {};
    Object.keys(payload).forEach(function (key) {
      if (key !== 'event') params[key] = payload[key];
    });
    params.transport_type = params.transport_type || 'beacon';
    window.gtag('event', payload.event, params);
  }
  window.__suecoLpTrack = push;
  document.addEventListener('visitorConsentCollected', function () {
    flushDeferredConsentLpView();
  });
  function yen(n) {
    return Number(n).toLocaleString('ja-JP');
  }
  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function lpVersion() {
    return (document.body && document.body.getAttribute('data-lp-version')) || 'c3';
  }
  function trackCtaClick(cta) {
    push({
      event: 'lp_cta_click',
      lp_version: lpVersion(),
      cta_location: cta.getAttribute('data-cta-location') || '',
      quantity: cta.getAttribute('data-quantity') || '',
      frequency: cta.getAttribute('data-frequency') || ''
    });
  }
  function injectStyle(id, css) {
    if (document.getElementById(id)) return;
    var st = document.createElement('style');
    st.id = id;
    st.textContent = css;
    document.head.appendChild(st);
  }
  function onScreen(el, ratio) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    if (r.height === 0) return false;
    var shown = Math.min(r.bottom, h) - Math.max(r.top, 0);
    return shown > 0 && shown / Math.min(r.height, h) >= (ratio || 0.25);
  }

  /* ============ 個数 × お届け間隔 ============ */
  function initPicker() {
    var picker = document.getElementById('lp3-picker');
    if (!picker) return;

    var buyBase = picker.getAttribute('data-buy-base') || '';
    var isolatedCheckout = buyBase === '/apps/documents/subscription-checkout';
    var directCartTransport = picker.getAttribute('data-checkout-transport') === 'storefront-cart-2026-04';
    // Public tokenless Storefront API: no app proxy, session lookup or private token.
    var checkoutEndpoint = 'https://suecofarm.myshopify.com/api/2026-04/graphql.json';
    var cartFields = 'id checkoutUrl totalQuantity attributes { key value } ' +
      'lines(first: 2) { nodes { id quantity merchandise { ... on ProductVariant { id } } ' +
      'sellingPlanAllocation { sellingPlan { id } } } }';
    var cartResultFields = 'cart { ' + cartFields + ' } userErrors { field message code } warnings { code message target }';
    var cartCreateQuery = 'mutation SuecoIsolatedSubscriptionCartCreate($input: CartInput!) { ' +
      'cartCreate(input: $input) { ' + cartResultFields + ' } }';
    var cartUpdateQuery = 'mutation SuecoIsolatedSubscriptionCartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) { ' +
      'cartLinesUpdate(cartId: $cartId, lines: $lines) { ' + cartResultFields + ' } }';
    var qtyInputs = all('input[name="lp3-qty"]', picker);
    var freqInputs = all('input[name="lp3-freq"]', picker);
    if (!qtyInputs.length || !freqInputs.length) return;

    var ctas = all('[data-lp3-cta]');
    var totals = all('[data-lp3-total]');
    var prices = all('[data-lp3-price]');
    var ships = all('[data-lp3-ship]');
    var labels = all('[data-lp3-planlabel]');
    var stickyPlan = all('[data-lp3-sticky-plan]');
    var stickyAmt = all('[data-lp3-sticky-amt]');
    var stickyBrk = all('[data-lp3-sticky-brk]');
    var checkoutStatus = picker.querySelector('[data-lp3-checkout-status]');
    var checkoutPending = false;
    var restoreCheckoutControls = null;
    var checkoutAttempt = 0;
    var preparedCheckout = null;
    var preparationRequests = 0;
    var preparationStopped = false;
    var preparationQueued = false;
    var preparationNotBefore = 0;
    var preparationTimer = null;

    function checked(list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].checked && !list[i].disabled) return list[i];
      }
      for (var j = 0; j < list.length; j++) {
        if (!list[j].disabled) return list[j];
      }
      return null;
    }

    function supportsPlan(qtyInput, freqInput) {
      if (!qtyInput || qtyInput.disabled || !freqInput) return false;
      var ids = (qtyInput.getAttribute('data-plan-ids') || '').split(',');
      return ids.indexOf(freqInput.getAttribute('data-plan')) !== -1;
    }

    function syncFrequencies(qtyInput) {
      var selected = null;
      var monthly = null;
      var first = null;
      freqInputs.forEach(function (freqInput) {
        var available = supportsPlan(qtyInput, freqInput);
        freqInput.disabled = !available;
        if (!available) freqInput.checked = false;
        if (available && !first) first = freqInput;
        if (available && freqInput.getAttribute('data-freq') === 'monthly') monthly = freqInput;
        if (available && freqInput.checked) selected = freqInput;
      });
      selected = selected || monthly || first;
      if (selected) selected.checked = true;
      return selected;
    }

    function setCtaState(enabled, href, variant, plan) {
      ctas.forEach(function (a) {
        a.classList.toggle('is-disabled', !enabled);
        if (enabled) {
          a.setAttribute('href', href);
          a.setAttribute('data-variant', variant);
          a.setAttribute('data-selling-plan', plan);
          a.removeAttribute('aria-disabled');
          a.removeAttribute('tabindex');
        } else {
          a.removeAttribute('href');
          a.removeAttribute('data-variant');
          a.removeAttribute('data-selling-plan');
          a.setAttribute('aria-disabled', 'true');
          a.setAttribute('tabindex', '-1');
        }
      });
    }

    function cleanAttributionValue(value, maxLength) {
      return String(value || '')
        .replace(/[\u0000-\u001f\u007f]/g, '')
        .trim()
        .slice(0, maxLength);
    }

    function checkoutAttribution() {
      var params = new URLSearchParams(window.location.search || '');
      var renderedProductKey = document.body && document.body.getAttribute('data-lp-product-key');
      var allowedProductKeys = [
        'egg-subscription-40',
        'egg-subscription-40-b',
        'egg-subscription-40-b1',
        'egg-subscription-40-start'
      ];
      if (allowedProductKeys.indexOf(renderedProductKey) === -1) return null;
      var landingPageKey = renderedProductKey;
      var attribution = {
        landing_page_key: landingPageKey
      };
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (key) {
        var value = cleanAttributionValue(params.get(key), 100);
        if (value) attribution[key] = value;
      });
      attribution.creative_key = cleanAttributionValue(
        params.get('creative_key') || attribution.utm_content || 'unattributed',
        100
      );
      return attribution;
    }

    function setCheckoutStatus(message) {
      if (!checkoutStatus) return;
      checkoutStatus.textContent = message || '';
      if (message) checkoutStatus.removeAttribute('hidden');
      else checkoutStatus.setAttribute('hidden', '');
    }

    function lockCheckoutControls() {
      var ctaState = ctas.map(function (cta) {
        var label = cta.querySelector('[data-lp3-cta-text]') || cta;
        var state = {
          cta: cta,
          label: label,
          labelNodes: Array.prototype.slice.call(label.childNodes),
          disabled: cta.getAttribute('aria-disabled'),
          tabindex: cta.getAttribute('tabindex'),
          busy: cta.getAttribute('aria-busy'),
          wasDisabledClass: cta.classList.contains('is-disabled')
        };
        cta.classList.add('is-disabled');
        cta.setAttribute('aria-disabled', 'true');
        cta.setAttribute('aria-busy', 'true');
        cta.setAttribute('tabindex', '-1');
        label.textContent = '購入画面を開いています…';
        return state;
      });
      var inputState = qtyInputs.concat(freqInputs, all('[data-e2-region]')).map(function (input) {
        var state = { input: input, disabled: input.disabled };
        input.disabled = true;
        return state;
      });
      picker.setAttribute('aria-busy', 'true');
      return function restore() {
        ctaState.forEach(function (state) {
          while (state.label.firstChild) state.label.removeChild(state.label.firstChild);
          state.labelNodes.forEach(function (node) { state.label.appendChild(node); });
          if (!state.wasDisabledClass) state.cta.classList.remove('is-disabled');
          if (state.disabled === null) state.cta.removeAttribute('aria-disabled');
          else state.cta.setAttribute('aria-disabled', state.disabled);
          if (state.tabindex === null) state.cta.removeAttribute('tabindex');
          else state.cta.setAttribute('tabindex', state.tabindex);
          if (state.busy === null) state.cta.removeAttribute('aria-busy');
          else state.cta.setAttribute('aria-busy', state.busy);
        });
        inputState.forEach(function (state) { state.input.disabled = state.disabled; });
        picker.removeAttribute('aria-busy');
      };
    }

    function selectedCheckoutPair(variant, plan) {
      var quantity = checked(qtyInputs);
      var frequency = checked(freqInputs);
      return /^\d+$/.test(variant) && /^\d+$/.test(plan) && supportsPlan(quantity, frequency) &&
        quantity.getAttribute('data-variant') === variant && frequency.getAttribute('data-plan') === plan;
    }

    function cartInput(payload) {
      return {
        lines: [{
          merchandiseId: 'gid://shopify/ProductVariant/' + payload.variant_id,
          sellingPlanId: 'gid://shopify/SellingPlan/' + payload.selling_plan_id,
          quantity: 1
        }],
        attributes: Object.keys(payload.attribution).map(function (key) {
          return { key: '__' + key, value: payload.attribution[key] };
        })
      };
    }

    function validateCartResponse(data, input, previousCart) {
      var result = data && data.data && data.data[previousCart ? 'cartLinesUpdate' : 'cartCreate'];
      if (!data || (data.errors !== undefined && (!Array.isArray(data.errors) || data.errors.length)) ||
          !result || !Array.isArray(result.userErrors) || result.userErrors.length || !Array.isArray(result.warnings)) {
        throw new Error('invalid_checkout_response');
      }
      var cart = result.cart;
      var lines = cart && cart.lines && cart.lines.nodes;
      var line = Array.isArray(lines) && lines.length === 1 ? lines[0] : null;
      var plan = line && line.sellingPlanAllocation && line.sellingPlanAllocation.sellingPlan;
      var attributes = cart && cart.attributes;
      if (!cart || typeof cart.id !== 'string' || !/^gid:\/\/shopify\/Cart\/[^\s]+$/.test(cart.id) ||
          (previousCart && cart.id !== previousCart.cartId) || cart.totalQuantity !== 1 ||
          !line || typeof line.id !== 'string' || !/^gid:\/\/shopify\/CartLine\/[^\s]+$/.test(line.id) || line.quantity !== 1 ||
          !line.merchandise || line.merchandise.id !== input.lines[0].merchandiseId ||
          !plan || plan.id !== input.lines[0].sellingPlanId ||
          !Array.isArray(attributes) || attributes.length !== input.attributes.length ||
          !input.attributes.every(function (expected) {
            return attributes.filter(function (actual) {
              return actual && actual.key === expected.key && actual.value === expected.value;
            }).length === 1;
          })) throw new Error('invalid_checkout_response');
      // A variant change may replace the line ID. Use the latest verified ID for the next update.
      var validated = { ok: true, checkoutUrl: cart.checkoutUrl, cartId: cart.id, lineId: line.id };
      if (!validatedCheckoutUrl(validated)) throw new Error('invalid_checkout_response');
      return validated;
    }

    function requestCheckout(payload, previousCart) {
      var input = cartInput(payload);
      var variables = previousCart ? { cartId: previousCart.cartId, lines: [{
        id: previousCart.lineId,
        merchandiseId: input.lines[0].merchandiseId,
        sellingPlanId: input.lines[0].sellingPlanId,
        quantity: 1
      }] } : { input: input };
      return new Promise(function (resolve, reject) {
        if (!directCartTransport || !document.body || document.body.getAttribute('data-lp-product-key') !== 'egg-subscription-40-start') {
          reject(new Error('invalid_checkout_transport'));
          return;
        }
        if (typeof window.fetch !== 'function') {
          reject(new Error('fetch_unavailable'));
          return;
        }
        var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
        var settled = false;
        var timer = window.setTimeout(function () {
          if (settled) return;
          settled = true;
          if (controller) controller.abort();
          reject(new Error('checkout_timeout'));
        }, 10000);

        window.fetch(checkoutEndpoint, {
          method: 'POST',
          credentials: 'omit',
          redirect: 'error',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ query: previousCart ? cartUpdateQuery : cartCreateQuery, variables: variables }),
          signal: controller ? controller.signal : undefined
        }).then(function (response) {
          if (!response.ok) throw new Error('checkout_http_error');
          return response.json();
        }).then(function (data) {
          if (settled) return;
          var validated = validateCartResponse(data, input, previousCart);
          settled = true;
          window.clearTimeout(timer);
          resolve(validated);
        }).catch(function (error) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          reject(error);
        });
      });
    }

    function validatedCheckoutUrl(data) {
      if (!data || data.ok !== true || typeof data.checkoutUrl !== 'string') return null;
      try {
        var url = new URL(data.checkoutUrl);
        return url.protocol === 'https:' && !url.username && !url.password && !url.port &&
          ['suecofarms.com', 'suecofarm.myshopify.com'].indexOf(url.hostname) !== -1 ? url.href : null;
      } catch (error) {
        return null;
      }
    }

    function stopPreparation() {
      window.clearTimeout(preparationTimer);
      preparationStopped = true;
      preparationQueued = false;
      preparedCheckout = null;
    }

    function preparationPayload() {
      var cta = ctas[0];
      if (!cta || cta.getAttribute('aria-disabled') === 'true') return null;
      var variant = cta.getAttribute('data-variant') || '';
      var plan = cta.getAttribute('data-selling-plan') || '';
      if (!selectedCheckoutPair(variant, plan)) return null;
      var attribution;
      try { attribution = checkoutAttribution(); } catch (error) { return null; }
      return attribution ? { variant_id: variant, selling_plan_id: plan, quantity: 1, attribution: attribution } : null;
    }

    function runPreparation() {
      if (!preparationQueued || preparationStopped || checkoutPending || document.visibilityState !== 'visible') return;
      var previous = preparedCheckout;
      // Only one mutation may operate on this cart. Coalesce later input until it settles.
      if (previous && !previous.ready && !previous.failed) return;
      preparationQueued = false;
      var payload = preparationPayload();
      if (!payload) return;
      var key = JSON.stringify(payload);
      if (previous) {
        if (previous.failed || Date.now() - previous.startedAt >= 120000 ||
            JSON.stringify(previous.payload.attribution) !== JSON.stringify(payload.attribution)) {
          stopPreparation();
          return;
        }
        if (previous.key === key) return;
      }
      // One background cart, at most two updates, and no automatic retries.
      if (preparationRequests >= 3 || (!previous && preparationRequests !== 0)) return;
      preparationRequests += 1;
      var entry = { key: key, payload: payload, startedAt: previous ? previous.startedAt : Date.now(), failed: false, ready: false };
      preparedCheckout = entry; // The previous URL is no longer safe once an update starts.
      entry.promise = requestCheckout(payload, previous ? previous.data : null).then(function (data) {
        if (preparedCheckout === entry && !preparationStopped) {
          entry.data = data;
          entry.ready = true;
          if (preparationQueued) {
            window.clearTimeout(preparationTimer);
            preparationTimer = window.setTimeout(runPreparation, Math.max(0, preparationNotBefore - Date.now()));
          }
        }
        return data;
      });
      // Unknown update outcomes invalidate the old URL; an explicit click can create afresh.
      entry.promise.catch(function () {
        entry.failed = true;
        if (preparedCheckout === entry) stopPreparation();
      });
    }

    // Purchase intent prepares one anonymous cart and follows the final selection.
    // IDs/URLs stay in memory; never load checkout or emit checkout events here.
    function scheduleCheckoutPreparation(event) {
      if (!event.isTrusted || !event.target || typeof event.target.closest !== 'function') return;
      var selectionIntent = event.type === 'change' && event.target.matches('[data-e2-region], input[name="lp3-qty"], input[name="lp3-freq"]');
      var entry = event.type === 'click' && event.target.closest('a[href="#lp3-plan"]');
      var entryIntent = entry && !entry.hasAttribute('data-lp3-cta');
      if (!selectionIntent && !entryIntent) return;
      if (event.target.matches('[data-e2-region]') && !event.target.value) return;
      window.clearTimeout(preparationTimer);
      if (preparationStopped || checkoutPending) return;
      preparationQueued = true;
      preparationNotBefore = Date.now() + 200;
      preparationTimer = window.setTimeout(runPreparation, 200);
    }

    function checkoutForClick(payload) {
      window.clearTimeout(preparationTimer);
      var entry = preparedCheckout;
      stopPreparation(); // one use, including an in-flight promise; cancel queued updates
      if (entry && !entry.failed && Date.now() - entry.startedAt < 120000 &&
          entry.key === JSON.stringify(payload)) return { promise: entry.promise, preparation: entry.ready ? 'ready' : 'pending' };
      return { promise: requestCheckout(payload), preparation: 'none' };
    }

    function initIsolatedCheckout() {
      push({ event: 'lp_picker_view', lp_version: lpVersion() });
      if (!isolatedCheckout) return;
      document.addEventListener('change', scheduleCheckoutPreparation);
      document.addEventListener('click', scheduleCheckoutPreparation);
      window.addEventListener('pagehide', function () {
        stopPreparation();
        checkoutAttempt += 1;
      });
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;
        stopPreparation();
        checkoutAttempt += 1;
        checkoutPending = false;
        if (restoreCheckoutControls) restoreCheckoutControls();
        restoreCheckoutControls = null;
        setCheckoutStatus('');
      });
      ctas.forEach(function (cta) {
        cta.addEventListener('click', function (event) {
          event.__suecoLpCtaHandled = true;
          event.preventDefault();
          if (checkoutPending || cta.getAttribute('aria-disabled') === 'true') return;

          var variant = cta.getAttribute('data-variant') || '';
          var plan = cta.getAttribute('data-selling-plan') || '';
          if (!selectedCheckoutPair(variant, plan)) {
            setCheckoutStatus('購入内容を確認できませんでした。個数とお届け間隔を選び直してください。');
            return;
          }

          var attribution = null;
          try {
            attribution = checkoutAttribution();
          } catch (error) {
            attribution = null;
          }
          if (!attribution) {
            setCheckoutStatus('購入ページを確認できませんでした。ページを再読み込みして、もう一度お試しください。');
            return;
          }

          checkoutPending = true;
          var attempt = ++checkoutAttempt;
          var clickStartedAt = performance.now();
          setCheckoutStatus('購入画面を準備しています。');
          trackCtaClick(cta);
          restoreCheckoutControls = lockCheckoutControls();
          var checkout = checkoutForClick({
            variant_id: variant,
            selling_plan_id: plan,
            quantity: 1,
            attribution: attribution
          });
          push({ event: 'lp_checkout_request', lp_version: lpVersion(), quantity: cta.getAttribute('data-quantity') || '', frequency: cta.getAttribute('data-frequency') || '', checkout_preparation: checkout.preparation });
          checkout.promise.then(function (data) {
            if (attempt !== checkoutAttempt) return;
            var checkoutUrl = validatedCheckoutUrl(data);
            if (!checkoutUrl) throw new Error('invalid_checkout_response');
            push({ event: 'lp_checkout_response', lp_version: lpVersion(), checkout_preparation: checkout.preparation, duration_ms: Math.round(performance.now() - clickStartedAt) });
            window.location.assign(checkoutUrl);
          }).catch(function (error) {
            if (attempt !== checkoutAttempt) return;
            var category = error && error.message === 'checkout_timeout' ? 'timeout' : (error && error.message === 'checkout_http_error' ? 'http' : 'invalid_response');
            push({ event: 'lp_checkout_error', lp_version: lpVersion(), error_category: category });
            checkoutPending = false;
            restoreCheckoutControls();
            restoreCheckoutControls = null;
            setCheckoutStatus('購入画面を開けませんでした。少し時間をおいて、もう一度お試しください。');
          });
        });
      });
    }

    function sync() {
      var q = checked(qtyInputs);
      var f = syncFrequencies(q);
      if (!q || !f) {
        setCtaState(false, '');
        return;
      }
      q.checked = true;

      var qty = q.getAttribute('data-qty');
      var price = q.getAttribute('data-price');
      var ship = q.getAttribute('data-ship');
      var total = q.getAttribute('data-total');
      var variant = q.getAttribute('data-variant');
      var plan = f.getAttribute('data-plan');
      var freqKey = f.getAttribute('data-freq');
      var freqLabel = f.getAttribute('data-label');

      var href = buyBase + '?id=' + encodeURIComponent(variant) +
        '&selling_plan=' + encodeURIComponent(plan) + '&quantity=1';
      if (isolatedCheckout) href = '#lp3-plan';

      setCtaState(true, href, variant, plan);
      ctas.forEach(function (a) {
        a.setAttribute('data-quantity', qty);
        a.setAttribute('data-frequency', freqKey);
        var t = a.querySelector('[data-lp3-cta-text]');
        if (t) t.textContent = qty + '個・' + freqLabel + 'で始める';
      });

      totals.forEach(function (e) { e.textContent = yen(total); });
      prices.forEach(function (e) { e.textContent = yen(price); });
      ships.forEach(function (e) { e.textContent = yen(ship); });
      labels.forEach(function (e) { e.textContent = qty + '個・' + freqLabel; });
      stickyPlan.forEach(function (e) { e.textContent = qty + '個・' + freqLabel; });
      stickyAmt.forEach(function (e) { e.textContent = yen(total) + '円'; });
      stickyBrk.forEach(function (e) {
        e.textContent = '／1回（商品' + yen(price) + '円＋関東送料' + yen(ship) + '円）';
      });
    }

    qtyInputs.forEach(function (el) {
      el.addEventListener('change', function () {
        sync();
        push({ event: 'lp_quantity_select', lp_version: lpVersion(), quantity: el.getAttribute('data-qty') });
      });
    });
    freqInputs.forEach(function (el) {
      el.addEventListener('change', function () {
        sync();
        push({ event: 'lp_frequency_select', lp_version: lpVersion(), frequency: el.getAttribute('data-freq') });
      });
    });

    sync();
    initIsolatedCheckout();
  }

  /* ============ CTA / LINE クリック計測 ============ */
  function initTracking() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var cta = e.target.closest('[data-lp3-cta]');
      if (cta) {
        if (e.__suecoLpCtaHandled === true) return;
        if (cta.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        trackCtaClick(cta);
        return;
      }
      var line = e.target.closest('[data-lp3-line]');
      if (line) {
        push({
          event: 'lp_line_click',
          lp_version: lpVersion(),
          cta_location: line.getAttribute('data-cta-location') || 'line'
        });
      }
    });
  }

  /* ============ セクション到達計測 ============ */
  function initViewTracking() {
    var marks = [
      { id: 'lp3-pack', event: 'lp_pack_section_view', done: false },
      { id: 'lp3-producer', event: 'lp_producer_section_view', done: false }
    ].filter(function (m) { return document.getElementById(m.id); });
    if (!marks.length) return;

    function check() {
      marks.forEach(function (m) {
        if (m.done) return;
        var el = document.getElementById(m.id);
        if (!el || !onScreen(el, 0.4)) return;
        m.done = true;
        push({ event: m.event, lp_version: lpVersion() });
      });
      if (marks.every(function (m) { return m.done; })) {
        window.removeEventListener('scroll', throttled);
        window.removeEventListener('resize', throttled);
      }
    }
    var ticking = false;
    function throttled() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; check(); });
    }
    window.addEventListener('scroll', throttled, { passive: true });
    window.addEventListener('resize', throttled);
    check();
  }

  /* ============ レビューカルーセル（自動再生つき） ============ */
  function initCarousel() {
    injectStyle('lp3-carousel-ui',
      '.lp3-playbar{display:flex;justify-content:center;margin-top:10px}' +
      '.lp3-play{display:inline-flex;align-items:center;gap:6px;min-height:44px;padding:0 14px;' +
      'border:1px solid #e5ded0;border-radius:999px;background:#fff;color:#2f664b;' +
      'font-family:inherit;font-size:12px;font-weight:600;line-height:1;cursor:pointer}' +
      '.lp3-play:hover{border-color:#3a7d5c}' +
      '.lp3-play:focus-visible{outline:3px solid #2f664b;outline-offset:2px}' +
      '.lp3-play .lp3-ico{display:inline-block;width:9px;height:11px;background:currentColor;' +
      'clip-path:polygon(0 0,38% 0,38% 100%,0 100%,0 0);position:relative}' +
      '.lp3-play .lp3-ico::after{content:"";position:absolute;right:0;top:0;width:38%;height:100%;background:currentColor}' +
      '.lp3-play[aria-pressed="true"] .lp3-ico{clip-path:polygon(0 0,100% 50%,0 100%)}' +
      '.lp3-play[aria-pressed="true"] .lp3-ico::after{display:none}'
    );

    all('[data-lp3-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-lp3-track]');
      if (!track) return;
      var cards = all('.lp3-rv', track);
      if (cards.length < 2) return;

      var prev = car.querySelector('[data-lp3-prev]');
      var next = car.querySelector('[data-lp3-next]');
      var dots = all('[data-lp3-dot]', car);
      var current = 0;
      var fromScript = false;

      var attr = car.getAttribute('data-autoplay');
      var showPlay = car.getAttribute('data-show-play') !== 'off';
      var interval = parseInt(car.getAttribute('data-autoplay-interval') || '5000', 10);
      if (!interval || interval < 2000) interval = 5000;
      var autoplayAllowed = attr !== 'off' && !reduceMotion;

      var timer = null;
      var userStopped = false;
      var hovering = false;
      var focused = false;

      function step() {
        if (cards.length < 2) return track.clientWidth;
        return cards[1].offsetLeft - cards[0].offsetLeft;
      }
      function indexFromScroll() {
        var s = step();
        return s > 0 ? Math.round(track.scrollLeft / s) : 0;
      }
      function paint(i) {
        current = Math.max(0, Math.min(i, cards.length - 1));
        dots.forEach(function (d, di) { d.setAttribute('aria-current', di === current ? 'true' : 'false'); });
        if (prev) prev.disabled = !autoplayAllowed && current === 0;
        if (next) next.disabled = !autoplayAllowed && current >= cards.length - 1;
      }
      function goTo(i, direction, silent) {
        var target = i;
        if (target < 0) target = cards.length - 1;
        if (target > cards.length - 1) target = 0;
        fromScript = true;
        track.scrollTo({ left: target * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
        paint(target);
        if (direction && !silent) {
          push({ event: 'lp_review_interaction', lp_version: lpVersion(), direction: direction, review_index: target });
        }
        window.setTimeout(function () { fromScript = false; }, 500);
      }

      /* --- 自動再生 --- */
      var playbar = null;
      var playBtn = null;

      function canRun() {
        return autoplayAllowed && !userStopped && !hovering && !focused &&
          !document.hidden && onScreen(car, 0.25);
      }
      function tick() {
        if (!canRun()) return;
        goTo(current + 1, 'next', true);
      }
      function start() { if (!timer) timer = window.setInterval(tick, interval); }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function refresh() { if (autoplayAllowed && !userStopped) start(); else stop(); }
      function setButton() {
        if (!playBtn) return;
        playBtn.setAttribute('aria-pressed', userStopped ? 'true' : 'false');
        playBtn.setAttribute('aria-label', userStopped ? 'レビューの自動切り替えを再生する' : 'レビューの自動切り替えを止める');
        playBtn.querySelector('.lp3-lbl').textContent = userStopped ? '自動再生' : '自動再生を止める';
      }

      if (autoplayAllowed) {
        if (showPlay) {
          playbar = document.createElement('div');
          playbar.className = 'lp3-playbar';
          playBtn = document.createElement('button');
          playBtn.type = 'button';
          playBtn.className = 'lp3-play';
          playBtn.innerHTML = '<span class="lp3-ico" aria-hidden="true"></span><span class="lp3-lbl"></span>';
          playbar.appendChild(playBtn);
          car.appendChild(playbar);
          setButton();

          playBtn.addEventListener('click', function () {
            userStopped = !userStopped;
            setButton();
            refresh();
          });
        }

        car.addEventListener('mouseenter', function () { hovering = true; });
        car.addEventListener('mouseleave', function () { hovering = false; });
        car.addEventListener('focusin', function () { focused = true; });
        car.addEventListener('focusout', function () { focused = false; });

        if (mq && mq.addEventListener) {
          mq.addEventListener('change', function (e) {
            reduceMotion = e.matches;
            autoplayAllowed = attr !== 'off' && !reduceMotion;
            if (!autoplayAllowed) { stop(); if (playbar) playbar.remove(); }
          });
        }
        refresh();
      }

      /* --- 手動操作 --- */
      function manual(i, direction) {
        stop();
        goTo(i, direction);
        window.setTimeout(refresh, interval);
      }
      if (prev) prev.addEventListener('click', function () { manual(current - 1, 'previous'); });
      if (next) next.addEventListener('click', function () { manual(current + 1, 'next'); });
      dots.forEach(function (d, di) {
        d.addEventListener('click', function () { manual(di, di > current ? 'next' : 'previous'); });
      });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); manual(current + 1, 'next'); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); manual(current - 1, 'previous'); }
        else if (e.key === 'Home') { e.preventDefault(); manual(0, 'previous'); }
        else if (e.key === 'End') { e.preventDefault(); manual(cards.length - 1, 'next'); }
      });

      var t;
      track.addEventListener('scroll', function () {
        window.clearTimeout(t);
        t = window.setTimeout(function () {
          var i = indexFromScroll();
          if (i === current) return;
          var wasScript = fromScript;
          paint(i);
          if (!wasScript) {
            push({ event: 'lp_review_interaction', lp_version: lpVersion(), direction: 'swipe', review_index: i });
          }
        }, 140);
      }, { passive: true });

      paint(0);
    });
  }

  /* ============ スクロールに合わせた控えめなフェードイン ============ */
  function initReveal() {
    if (reduceMotion) return;

    injectStyle('lp3-reveal-style',
      '.lp3-reveal{opacity:0;transform:translateY(14px);' +
      'transition:opacity .55s ease-out,transform .55s ease-out}' +
      '.lp3-reveal.lp3-in{opacity:1;transform:none}'
    );

    var targets = [];
    all('.lp3').forEach(function (sec) {
      if (sec.classList.contains('lp3-hero')) return;
      all(':scope > .lp3-w, :scope > .lp3-w-wide, :scope > .lp3-w-xwide', sec).forEach(function (el) {
        targets.push(el);
      });
    });
    if (!targets.length) return;

    var pending = targets.slice();
    targets.forEach(function (el) { el.classList.add('lp3-reveal'); });

    function reveal(el) {
      el.classList.add('lp3-in');
      var i = pending.indexOf(el);
      if (i > -1) pending.splice(i, 1);
      if (!pending.length) teardown();
    }
    function sweep() {
      pending.slice().forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 0) * 0.92 && r.bottom > 0) reveal(el);
      });
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sweep(); });
    }
    function teardown() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      window.removeEventListener('load', sweep);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', sweep);
    sweep();
  }

  function boot() {
    initPicker();
    initTracking();
    initViewTracking();
    initCarousel();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* lp40sub-e4 — E2の価格・送料・購入挙動を保ったE4用スクリプト
 *
 * 個数×間隔ピッカー本体、レビューカルーセル、スクロール演出、CTA計測は
 * lp40sub-c3.js がそのまま担当する。ここはその上に足すぶんだけを持つ。
 *
 * E1からの一番の違い:
 *   お届け先を選ぶまで総額を出さない。
 *   E1は関東を例に「総額4,680円」を大きく出していたが、関東以外の人にとっては
 *   自分の金額ではないので、確かめ直す手間が増える。
 *   購入カードでは送料幅を先に強調せず、地域を選んだ時点で明細と総額を出す。
 *
 * このファイルがやること:
 *   1. 個数と地域から、送料・総額・1個あたり・お得額を出す
 *   2. 地域を選ぶまで総額を隠す（固定CTAも同じ扱いにする）
 *   3. お客様の声を、商品ページへ飛ばさずにこのページで追加表示する
 *   4. カルーセルを指で触れたら自動で切り替わらないようにする
 *   5. 固定CTAをファーストビューを過ぎてから出す
 *
 * c3 側の内部状態には触らない。自動再生の一時停止は、c3 が既に持っている
 * mouseenter / mouseleave の口を使って外から知らせる。
 * 送料と総額に data-lp3-ship / data-lp3-total を使わないこと。
 * それらは c3.js が関東の値で上書きしてしまう。E2は data-e2-* を使う。
 *
 * 固定CTAの出し入れに requestAnimationFrame のスロットルを使わないこと。
 * 読み込み時にタブが裏にあるとコールバックが来ず、実行中フラグが立ったままになって
 * それ以降のスクロールが全部素通りする。読むのは要素1つの矩形だけなので直接呼ぶ。
 *
 * JSが動かない環境では、購入カードのCTAは安全な選択欄へのリンクを保持する。
 * 購入リンクへの切替と、送料込み総額の確定はJavaScriptが動く場合だけ行う。
 */
(function () {
  'use strict';
  if (window.__lp40subE4) return;
  window.__lp40subE4 = true;

  function lpVersion() {
    return (document.body && document.body.getAttribute('data-lp-version')) || 'e4';
  }

  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function yen(n) {
    return Number(n).toLocaleString('ja-JP');
  }
  function num(el, attr) {
    return parseInt((el && el.getAttribute(attr)) || '0', 10) || 0;
  }
  function push(payload) {
    if (typeof window.__suecoLpTrack === 'function') {
      window.__suecoLpTrack(payload);
    }
  }

  /* ============ 1・2. 個数 × お届け先 ============ */
  function initPrice() {
    var qtyInputs = all('input[name="lp3-qty"]');
    var freqInputs = all('input[name="lp3-freq"]');
    var selects = all('[data-e2-region]');
    if (!qtyInputs.length) return;

    var regionValue = '';

    function checkedQty() {
      for (var i = 0; i < qtyInputs.length; i++) if (qtyInputs[i].checked) return qtyInputs[i];
      return qtyInputs[0];
    }

    function checkedFrequency() {
      for (var i = 0; i < freqInputs.length; i++) {
        if (freqInputs[i].checked && !freqInputs[i].disabled) return freqInputs[i];
      }
      return null;
    }

    function syncRegionRequiredCtas(hasRegion) {
      all('[data-e2-region-required]').forEach(function (cta) {
        var enabled = hasRegion && cta.hasAttribute('href');
        cta.classList.toggle('is-disabled', !enabled);
        if (enabled) {
          cta.removeAttribute('aria-disabled');
          cta.removeAttribute('tabindex');
        } else {
          cta.setAttribute('aria-disabled', 'true');
          cta.setAttribute('tabindex', '-1');
        }
      });
    }

    function currentOption() {
      if (!selects.length || regionValue === '') return null;
      var opts = all('option', selects[0]);
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].value === regionValue) return opts[i];
      }
      return null;
    }

    function shipRange(size) {
      var opts = selects.length ? all('option[data-ship80]', selects[0]) : [];
      var min = 0;
      var max = 0;
      opts.forEach(function (o) {
        var v = num(o, size === '60' ? 'data-ship60' : 'data-ship80');
        if (!v) return;
        if (!min || v < min) min = v;
        if (v > max) max = v;
      });
      return { min: min, max: max };
    }

    function sync() {
      var q = checkedQty();
      if (!q) return;
      var f = checkedFrequency();

      var qty = num(q, 'data-qty');
      var price = num(q, 'data-price');
      var once = num(q, 'data-once');
      var size = q.getAttribute('data-size') === '60' ? '60' : '80';
      var save = once > price ? once - price : 0;
      var unit = qty > 0 ? Math.round(price / qty) : 0;
      var discount = once > 0 ? Math.round(save * 100 / once) : 0;
      var packCount = qty > 0 ? Math.round(qty / 10) : 0;
      var frequencyLabel = f ? f.getAttribute('data-label') : '月1回';
      var range = shipRange(size);

      all('[data-e2-save], [data-e1-save]').forEach(function (e) { e.textContent = yen(save); });
      all('[data-e2-unit], [data-e1-unit]').forEach(function (e) { e.textContent = yen(unit); });
      all('[data-e2-once]').forEach(function (e) { e.textContent = yen(once); });
      all('[data-e2-discount]').forEach(function (e) { e.textContent = discount; });
      all('[data-e2-packcount]').forEach(function (e) { e.textContent = packCount; });
      all('[data-e2-frequency]').forEach(function (e) { e.textContent = frequencyLabel; });
      all('[data-e2-price]').forEach(function (e) { e.textContent = yen(price); });
      all('[data-e2-qty], [data-e1-qty]').forEach(function (e) { e.textContent = qty + '個'; });
      all('[data-e2-shiprange]').forEach(function (e) {
        e.textContent = range.min ? yen(range.min) + '円〜' + yen(range.max) + '円' : '';
      });

      // 地域別の一覧（開いたときだけ見る側）も、選んだ個数に合わせておく
      all('[data-e1-region]').forEach(function (row) {
        var rowShip = num(row, size === '60' ? 'data-ship60' : 'data-ship80');
        var s = row.querySelector('[data-e1-region-ship]');
        var t = row.querySelector('[data-e1-region-total]');
        if (s) s.textContent = yen(rowShip) + '円';
        if (t) t.textContent = yen(price + rowShip) + '円';
      });

      var opt = currentOption();
      var stickyNote;

      if (opt) {
        var ship = num(opt, size === '60' ? 'data-ship60' : 'data-ship80');
        var total = price + ship;
        all('[data-e2-ship]').forEach(function (e) { e.textContent = yen(ship); });
        all('[data-e2-total]').forEach(function (e) { e.textContent = yen(total); });
        all('[data-e2-regionname]').forEach(function (e) { e.textContent = opt.textContent; });
        all('[data-e2-totalwrap]').forEach(function (e) { e.removeAttribute('hidden'); });
        all('[data-e2-region-hint]').forEach(function (e) { e.setAttribute('hidden', ''); });
        all('[data-e2-sticky-amt]').forEach(function (e) { e.textContent = yen(total) + '円'; });
        syncRegionRequiredCtas(true);
        stickyNote = '／1回（商品' + yen(price) + '円＋' + opt.textContent + '送料' + yen(ship) + '円）';
      } else {
        all('[data-e2-totalwrap]').forEach(function (e) { e.setAttribute('hidden', ''); });
        all('[data-e2-region-hint]').forEach(function (e) { e.removeAttribute('hidden'); });
        all('[data-e2-sticky-amt]').forEach(function (e) { e.textContent = yen(price) + '円'; });
        syncRegionRequiredCtas(false);
        stickyNote = '／1回・お届け先を選ぶと送料込み総額を表示';
      }
      all('[data-e2-sticky-note]').forEach(function (e) { e.textContent = stickyNote; });
    }

    qtyInputs.forEach(function (el) { el.addEventListener('change', sync); });
    freqInputs.forEach(function (el) { el.addEventListener('change', sync); });

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        regionValue = sel.value;
        selects.forEach(function (other) { if (other !== sel) other.value = regionValue; });
        sync();
        if (regionValue !== '') {
          push({
            event: 'lp_region_select',
            lp_version: lpVersion(),
            region: sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent : ''
          });
        }
      });
    });

    sync();
  }

  /* ============ 3. お客様の声を、このページで追加表示する ============ */
  function initMoreReviews() {
    all('[data-e1-more], [data-e2-more]').forEach(function (btn) {
      var list = document.getElementById(btn.getAttribute('aria-controls') || '');
      if (!list) return;

      btn.addEventListener('click', function () {
        list.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        push({
          event: 'lp_review_more',
          lp_version: lpVersion(),
          review_count: all('.lp3-rv', list).length
        });
        var first = list.querySelector('.lp3-rv');
        if (first) {
          first.setAttribute('tabindex', '-1');
          first.focus({ preventScroll: true });
        }
        var wrap = btn.parentNode;
        if (wrap) wrap.removeChild(btn);
      });
    });
  }

  /* ============ 4. 指で触れているあいだは自動で切り替えない ============ */
  function initTouchPause() {
    all('[data-lp3-carousel]').forEach(function (car) {
      var timer = null;

      function pause() {
        car.dispatchEvent(new MouseEvent('mouseenter'));
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          car.dispatchEvent(new MouseEvent('mouseleave'));
        }, 30000);
      }

      car.addEventListener('touchstart', function (e) {
        if (e.target && e.target.closest && e.target.closest('.lp3-play, .lp3-nav, .lp3-dots')) return;
        pause();
      }, { passive: true });
    });
  }

  /* ============ 5. 固定CTAは本文の閲覧中だけ表示する ============ */
  function initSticky() {
    var bar = document.querySelector('.lp3-sticky');
    var hero = document.querySelector('.lp3-hero');
    if (!bar || !hero) return;

    bar.classList.add('lp3e-sticky');
    var purchaseAreas = all('#lp3-plan, .lp3-final');

    function check() {
      var purchasing = purchaseAreas.some(function (area) {
        var rect = area.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });
      var hidden = hero.getBoundingClientRect().bottom >= 48 || purchasing;
      bar.classList.toggle('lp3e-sticky-off', hidden);
      bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      bar.inert = hidden;
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    document.addEventListener('change', check);
    document.addEventListener('toggle', check, true);
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(check);
      purchaseAreas.forEach(function (area) { observer.observe(area); });
    }
    check();
  }

  /* ============ 計測 ============ */
  function initTracking() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var soft = e.target.closest('[data-e1-softcta], [data-e2-softcta]');
      if (soft) {
        push({
          event: 'lp_soft_cta_click',
          lp_version: lpVersion(),
          cta_location: soft.getAttribute('data-cta-location') || ''
        });
      }
    });

    all('[data-e1-regions]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        push({
          event: 'lp_region_table_open',
          lp_version: lpVersion(),
          cta_location: d.getAttribute('data-cta-location') || ''
        });
      });
    });

    push({ event: 'lp_view', lp_version: lpVersion() });
  }

  /* ============ 合わせ買い商品（手動スクロールのみ） ============ */
  function initAddonCarousel() {
    all('[data-e4-addon]').forEach(function (root) {
      var track = root.querySelector('[data-e4-addon-track]');
      var prev = root.querySelector('[data-e4-addon-prev]');
      var next = root.querySelector('[data-e4-addon-next]');
      if (!track) return;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function stepSize() {
        var card = track.querySelector('[data-e4-addon-card]');
        if (!card) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      function move(direction) {
        track.scrollBy({
          left: stepSize() * direction,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  function boot() {
    initPrice();
    initMoreReviews();
    initTouchPause();
    initSticky();
    initTracking();
    initAddonCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
